import { render } from "./Shinseisyolist.vue?vue&type=template&id=2a77755a&scoped=true&ts=true"
import script from "./Shinseisyolist.vue?vue&type=script&lang=ts"
export * from "./Shinseisyolist.vue?vue&type=script&lang=ts"

import "./Shinseisyolist.vue?vue&type=style&index=0&id=2a77755a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1530414395/src/mediadept-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a77755a"]])

export default __exports__